export const operationChange = {
  Liste: {
    table: {
      title: 'Liste des opérations de change',
      paid: 'Payée',
      message_confirm_deal: 'Voulez-vous valider ce deal {{code}}',
      message_confirm_denouer: 'Voulez-vous dénouer le deal {{code}}',
      message_confirm_soulte: 'Voulez-vous payer la soulte du deal {{code}} ?',
      audit_action: 'Liste des actions réalisées',
      calendar: 'Calendrier',
      or: 'OU',
      and: 'ET',
      tree: 'Arbre',
      list: 'Liste',
      culumn: {
        state: 'Etat',
        code_deal: 'Référence externe',
        date_spot: 'Date Spot',
        compte_dept: 'Compte débité',
        amount1: 'Montant 1',
        availableAmount: 'Montant restant Devise 1',
        dev1: 'Devise 1',
        account_credt: 'Compte crédité',
        amount2: 'Montant 2',
        dev2: 'Devise 2',
        currency: ' Devise',
        soult: 'Soulte devise 2 devise 2',
        accountdev1: 'Compte Devise 1',
        accountdev2: 'Compte Devise 2',
        sens: 'Sens',
        taux1: 'Spot',
        taux2: 'Term',
        py_terme: 'Points de Terme',
        lib: 'Libellé',
        date_opera: "Date d'opération",
        date_term: "Date d'échéance",
        value_date: 'Date de valeur',
        balance_date: "Date d'échéance",
        accrual_date: 'Date de tombée',
        business_code: 'Code affaire',
        update_timestamp: 'Date Modification',
        create_timestamp: 'Date Création',
        log: 'Login',
        society: 'Société',
        account1: 'Compte 1',
        account2: 'Compte 2',
        b2b: 'B2B',
        b2baccount1: 'Compte B2B 1',
        b2baccount2: 'Compte B2B 2',
        type: 'Type',
        origin: 'Origine',
        code: 'Contrat',
      },
    },

    fiche: {
      titles: {
        edit_title: "Fiche d'opération change {{code}}",
        new_title: "Création d'un nouveau opération change",
        view_title: 'Fiche du compte courant',
      },
      champs: {
        state: 'Etat',
        code_deal: 'Référence externe',
        business_code: 'Code affaire',
        date_spot: 'Date Spot',
        compte_dept: 'Compte débité',
        amount1: 'Montant 1',
        dev1: 'Devise 1',
        date_term: "Date d'échéance",
        account_credt: 'Compte crédité',
        amount2: 'Montant 2',
        dev2: 'Devise 2',
        sens: 'Sens',
        taux1: 'Cours spot',
        taux2: 'Cours term',
        py_terme: 'Points de Terme',
        lib: 'Libellé',
        log: 'Login',
        description: 'Description',
        type: 'Type',
        date_opera: "Date de l'opération",
        comment: 'Commentaire',
        balance: 'Balance',
        paiement: 'Mode de paiement',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
    },
    drawer_denoue: {
      title: 'Validation du deal {{code}}',
      title_maket_room: 'Flux vers salle de marché ',
      title_company: 'Flux vers société',
      title_intermediaire_company: 'Flux vers intermediaire',
      champs: {
        flow: 'Flux',
        account_company: 'Compte société',
        room_market: 'Compte salle marché',
        account_company2: 'Compte holding',
        room_market2: 'Compte société',
        label: 'Libellé',
        nature_debit: 'Nature Débit',
        nature_credit: 'Nature Crédit',
        amount: 'Montant',
        value_date: 'Date Valeur',
        account_intermediary: 'Compte intermédiaire',
      },
    },
    drawer_soult: {
      title: 'Modification soulte',
    },
  },
}

